module.exports = __webpack_public_path__ + "img/img-online-inv.8e88afd2.svg";